export const UPDATE_DASHBOARD = 'UPDATE_DASHBOARD';
export const UPDATE_DASHBOARD_ERROR = 'UPDATE_DASHBOARD_ERROR';
export const GET_DASHBOARD = 'GET_DASHBOARD';
export const SET_DASHBOARD = 'SET_DASHBOARD';